module.exports = __webpack_public_path__ + "img/itx-file-type-json.f26ccf7c.svg";